import React from "react";

import GLOBAL from "../../../global";
import crossBtn from "../../../assets/img/utils/cross.svg";

const ChatbotHeader = (props) => {
    const toggleChatModal = props?.toggleChatModal || (() => {});

    return (
        <div className={`displayFlex justify-between chat-bot-header-background-color w-100-percent`}>
            <div>
                <a rel="noopener noreferrer"
                   href={"!#"} onClick={(e) => e.preventDefault()}
                   className="  cursor-hand">
                    <>
                        {GLOBAL.LOGO_URL
                            ? <img src={GLOBAL.LOGO_URL} height="50" className="logo" alt="Logo"/>
                            : <img src={GLOBAL.WHITE_LOGO_URL} height="50" className="logo" alt="Logo"/>
                        }
                    </>
                </a>
            </div>
            <div>
                <button type="button"
                        onClick={toggleChatModal}
                        className="btn"
                        data-dismiss="modal">
                    <img src={crossBtn} alt="close"/>
                </button>
            </div>
        </div>
    )
}

export default ChatbotHeader;